import { yupResolver } from '@hookform/resolvers/yup';
import SearchIcon from '@mui/icons-material/Search';
import { useForm } from 'react-hook-form';

import { useEffect } from 'react';
import { debounce } from 'utils/debounce';
import { useStoreSelector } from 'v3/data/store';
import {
  clearAvailableFilter,
  clearModelFilter,
  setModelNameFilter,
  setPage,
  setProductAvailability,
} from 'v3/data/store/product/actions';
import { getStorePermissions } from 'v3/data/store/stores/actions';
import { StoreProfileEnum } from 'v3/data/store/stores/enums';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { DropdownSelectFormController } from 'v3/shared/components/Inputs/DropdownSelectFormController';
import { InputFormController } from 'v3/shared/components/Inputs/InputFormController';
import { smartphoneSchema } from 'v3/shared/schemas/smartphones';
import { BodyLarge } from 'v3/shared/typography/BodyLarge';
import { AvailableStatusEnum, availableStatusMap } from './enum';
import { CardContentStyled, CardStyled } from './styles';
import { ProductFilterType } from './types';

export const SmartphoneFilter = () => {
  const DEBOUNCE_DELAY = 1000;

  const { control, getValues, setValue, clearErrors } = useForm<ProductFilterType>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(smartphoneSchema) as any,
  });
  const { isGroupAdmin } = getStorePermissions();

  const { group } = useStoreSelector((store) => store.store.storeLogged);

  const isStore = group === StoreProfileEnum.STORE;

  const handleSearchSmartphone = (model: string) => {
    setModelNameFilter(model);
    setPage(0);
  };

  const debouncedHandleSearchSmartphone = (model: string) => {
    debounce(() => handleSearchSmartphone(model), DEBOUNCE_DELAY, 'handleSearchSmartphone');
  };

  const handleOnChange = (model: string) => {
    debouncedHandleSearchSmartphone(model);
  };

  const handleOnChangeAvailability = (available: AvailableStatusEnum) => {
    setProductAvailability(availableStatusMap(available));
  };

  const handleClearFilter = () => {
    setValue('smartphone', undefined);
    setValue('status', AvailableStatusEnum.Todos);
    clearModelFilter();
    clearAvailableFilter();
    clearErrors();
  };

  useEffect(() => {
    return setProductAvailability(null);
  }, []);

  return (
    <CardStyled>
      <BodyLarge>Filtros</BodyLarge>
      <CardContentStyled>
        <InputFormController
          data-testid="input-smartphone"
          formControl={control}
          formControlName="smartphone"
          placeholder="Buscar por smartphone"
          fullWidth
          onChangeInput={handleOnChange}
          startAdornmentIcon={SearchIcon}
          hasErrorField={false}
        />

        {isStore ||
          (isGroupAdmin && (
            <DropdownSelectFormController
              data-testid="select-form-controller-status"
              formControl={control}
              formControlName="status"
              label="Status"
              enumType={true}
              selectValues={AvailableStatusEnum}
              onChangeSelect={handleOnChangeAvailability}
              key={getValues('status')}
            />
          ))}

        <TextButton data-testid="clean" text="Limpar" handleClick={handleClearFilter} />
      </CardContentStyled>
    </CardStyled>
  );
};
